import React from "react"
import CustomImage from "@/main/customImage"
import { Container, Row, Col, Button } from "react-bootstrap"

function MiscHeroImage(props) {
    return (
        <>
            {/* Hero Image */}
            <Container fluid className="p-0 overflow-hidden">
                <Row className="m-0 gx-0">
                    <div className="misc-parallax">
                        <CustomImage
                            src={`https://webb-jenkins-static-164679926.imgix.net/heroes/${props.image}`}
                            alt={props.alt}
                            layout="fill"
                            objectFit="cover"
                            objectPosition={props.position}
                            className="background-image"
                            priority
                        />

                        {/* Main Overlay */}
                        <div className="wjoverlay">
                            <Container fluid="md">
                                <Row className="gx-0 align-items-center justify-content-center misc-parallax-content">
                                    <Col xs={12} xxl={10}>
                                        <h1 className="text-white text-center px-2 px-lg-0">
                                            {props.title}
                                        </h1>
                                        <span className="text-lg text-white text-center px-2 px-lg-0 d-flex justify-content-center">
                                            {props.subtitle}
                                        </span>
                                        <span className="text-lg text-white text-center px-2 px-lg-0 d-flex justify-content-center">
                                            {props.subtitle2}
                                        </span>
                                        <span className="text-lg text-white text-center px-2 px-lg-0 d-flex justify-content-center">
                                            {props.subtitle3}
                                        </span>
                                        {props.buttonText && (
                                            <div className="w-100 text-center hero-btn mt-4">
                                                <Button
                                                    size="lg"
                                                    variant="bg-white"
                                                    className="px-3 px-xl-4 bg-white"
                                                    onClick={
                                                        props.buttonOnClick
                                                    }
                                                >
                                                    <span className="p-0 text-warning text-bold">
                                                        {props.buttonText}
                                                    </span>
                                                </Button>
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        {/* Main Overlay End */}
                    </div>
                </Row>
            </Container>
            {/* Hero Image End */}
        </>
    )
}

export default MiscHeroImage
